interface ToggleProps {
  onChange: (checked: boolean) => void;
  checked: boolean;
  disabled?: boolean;
  label?: string;
}

function Toggle({ onChange, checked, disabled, label }: ToggleProps) {
  return (
    <label className={`inline-flex items-center cursor-pointer ${disabled ? 'cursor-not-allowed' : ''}`}>
      <input
        type='checkbox'
        data-cy='toggle'
        checked={checked}
        disabled={disabled}
        aria-checked={checked}
        aria-disabled={disabled}
        className='sr-only peer'
        onChange={(event) => !disabled && onChange(event.target.checked)}
      />
      <div
        className={`relative min-w-[48px] h-6 rounded-full peer peer-focus:ring-5 peer-focus:ring-blue-300 ${disabled ? 'bg-gray-100' : 'bg-gray-300'} ${disabled ? 'peer-checked:bg-[#7bd81767]' : 'peer-checked:bg-[#7ad817]'} peer-checked:after:translate-x-[calc(100%+5px)] peer-checked:after:border-white after:content-[''] after:absolute after:top-[3px] after:start-[3px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[18px] after:w-[18px] after:transition-all`}
      ></div>
      {label && <span className={`ms-3 text-md ${disabled ? 'text-gray-500' : 'text-gray-900'}`}>{label}</span>}
    </label>
  );
}

export default Toggle;
